import { InjectionToken } from '@angular/core';
import { IQuestionComponent } from './question.model';

export const QUESTIONS = new InjectionToken<IQuestionComponent[]>('Questions');
